import React, { useEffect, useState } from "react";
import { chartHeaderIds } from "../../utils/constants";

const ToDoColumnModifier = ({ initialColumnValues, saveColumnValues }) => {
  const [columnValues, setColumnValues] = useState({ ...initialColumnValues });
  const [checkAll, setCheckAll] = useState(false);

  const styles = {
    filterCheckbox: {
      width: "20px",
      height: "20px",
    },
  };

  useEffect(() => {
    if (initialColumnValues) {
      setColumnValues({ ...initialColumnValues });
    }
  }, [initialColumnValues]);

  const onSaveColumns = () => {
    saveColumnValues({ ...columnValues });
  };

  const checkAllFn = () => {
    const headers = { ...chartHeaderIds };
    Object.keys(headers).forEach((i) => {
      headers[i] = !checkAll;
    });
    setCheckAll(!checkAll);
    setColumnValues(headers);
  };

  return (
    <div
      className="modal fade  filter-dropdown mt-6"
      tabIndex="-1"
      id="column-modifier"
    >
      <div className="modal-dialog">
        <div className="modal-content ">
          <div className="p-5 d-flex flex-row justify-content-between">
            <div>
              <h1>Columns Visibility</h1>
              <p className="text-gray-400 mt-1 fw-semibold fs-6">
                You can select below the columns to show or hide.
              </p>
            </div>
            <div
              className="btn btn-icon btn-sm btn-active-light-primary ms-2"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              X
            </div>
          </div>
          <div className="separator border-gray-200"></div>
          <div className="h-400px scroll-y">
            <table
              className="table to-do-table align-middle table-row-dashed fs-6 gy-5 gs-7"
              id="example"
            >
              <thead>
                <tr className="text-start fw-bold fs-7 text-uppercase gs-0">
                  <th className="min-w-80px">FIELD</th>
                  <th className="min-w-200px">
                    <input
                      id="check-all-button"
                      onChange={checkAllFn}
                      className="form-check-input me-3 "
                      style={styles.filterCheckbox}
                      type="checkbox"
                      data-column="0"
                      value="report"
                      checked={checkAll}
                    />
                    <label htmlFor="check-all-button">
                      {checkAll ? "Unselect All" : "Select All"}
                    </label>
                  </th>
                </tr>
              </thead>
              <tbody className="text-gray-600 fw-semibold ">
                {Object.entries(chartHeaderIds).map(([id, name], index) => (
                  <tr key={`data-row-${index}`}>
                    <td key={`head-mod-${index}`}>{name}</td>
                    <td key={`data-mod-${index}`}>
                      <input
                        onChange={() => {
                          const colVals = { ...columnValues };
                          colVals[id] = !colVals[id];
                          setColumnValues(colVals);
                        }}
                        className="form-check-input "
                        style={styles.filterCheckbox}
                        type="checkbox"
                        data-column="0"
                        value="report"
                        checked={!!columnValues[id]}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="d-flex justify-content-center mb-5">
            <button className="btn btn-secondary me-5" data-bs-dismiss="modal">
              Discard
            </button>
            <button
              onClick={onSaveColumns}
              className="btn btn-primary"
              data-bs-dismiss="modal"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ToDoColumnModifier;
